import SubscriptionsTable from "./SubscriptionsTable"

export default  SubscriptionsTable;



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionsWithGroups/SubscriptionsTable/index.js